import React, { Component } from 'react';
import { connect } from 'react-redux'
import autobind from 'autobind-decorator';
import { Navbar, NavRight, Link, NavTitle, Icon, Badge, Page, NavLeft } from 'framework7-react';
import { changeVisibleSearchView, changeVisibleCartView } from 'core/module/operations';

import { withLocale } from 'core/decorators';
import classes from './styles.module.css';

class SikaPage extends Component {
  constructor(props) {
    super(props);

    this.state = {}
  }

  static get defaultProps() {
    return {
      showBack: true,
      showClose: false,
      showSearch: false,
      showCart: false,
      backLink: true,
      background: '',
      backText: 'بازگشت',
      closeText: 'بستن',
      background: null,
    }
  }

  componentDidMount() {
    // console.log(this.$f7.views.main.router.history)
    // console.log(this.$f7.views.current.router.history)

    // const { navigate } = this.props
    // console.log("==== navigate histroy length:", navigate.history.length)
  }

  // componentDidUpdate(prevProps) {
  //   const { pageName, navigate } = this.props

  //   if (navigate.history == prevProps.navigate.history) return

  //   console.log("==== Base Page Render ====")
  //   console.log(`======= ${pageName} ====`)
  //   if (navigate) {
  //     console.log("==== navigate:", navigate)
  //     console.log("==== navigate histroy length:", navigate.history.length)
  //     // console.log("==== previous navigate typeof:", typeof navigate.previousRoute)
  //     // console.log("==== previous navigate:", navigate.previousRoute)
  //     console.log("==== previous navigate path:", navigate.previousRoute.path)
  //   }
  // }

  searchClicked() {
    // this.$f7.$('#view-search').addClass('modal-in')
    this.props.changeVisibleSearchView(true)
  }

  cartClicked() {
    // this.$f7.$('#view-cart').addClass('modal-in')
    this.props.changeVisibleCartView(true)
  }

  render() {
    const { pageName, title, backText, closeText, showBack, showSearch, showCart, showClose, closePopup, closePopupClassName, cart, background, env } = this.props;

    let _showBack = showBack // && (navigate && navigate.history && navigate.history.length >= 1)

    // console.log(pageName, ', f7router:', this.$f7router, ', history length:', this.$f7router && this.$f7router.history && this.$f7router.history.length)
    // console.log(pageName, ':', _showBack, ', navigate: ', navigate, 'history length:', navigate && navigate.history && navigate.history.length, ', showBack', showBack)

    let navLeftCloseProps = {}
    if (closePopup) {
      navLeftCloseProps.popupClose = closePopupClassName || true
    }

    return (
      <Page infinitePreloader={false} name={pageName}>
        <Navbar>
          <NavLeft
            backLink={_showBack && backText}
            backLinkShowText={backText ? true : false}
            onBackClick={this.props.onBackNavClicked}
            onClickBack={this.props.onBackNavClicked}
          >
            {showClose && !showBack &&
              <Link
                {...navLeftCloseProps}
                onClick={this.props.onCloseNavClicked}
              >
                {closeText}
              </Link>
            }
            {false && // debug android back button
              <Link
                icon='mdi-view-agenda'
                onClick={(e) => {
                  // #view-home.view.view-main.tab-active.tab
                  const f7 = this.$f7
                  const $ = f7.$

                  console.log('current view name:', f7.views.current);
                  const currentView = f7.views.current;

                  const popupIns = $('.popup.modal-in')
                  if (popupIns.children('.view')) {
                    if (currentView && currentView.router && currentView.router.history.length > 1) {
                      currentView.router.back();
                      e.preventDefault();
                      return false;
                    } else {
                      // console.log(popupIns[popupIns.length - 1].id)
                      // this.$f7.popup.close(`#${popupIns[popupIns.length - 1].id}`)
                      f7.popup.close(popupIns[popupIns.length - 1])
                    }
                  }

                  if (currentView && currentView.router && currentView.router.history.length > 1) {
                    currentView.router.back();
                    // e.preventDefault();
                    return false;
                  } else if (currentView && currentView.router && currentView.router.history.length <= 1) {
                    if (currentView.name == 'home') {
                      e.preventDefault();
                      f7.dialog.confirm('آیا قصد خروج از برنامه را دارید؟', () => window.navigator.app.exitApp())
                      return true;
                      // } else if (currentView.name == 'search') {
                      //   viewSearchEl.hide()
                      // } else if (currentView.name == 'cart') {
                      //   viewCartEl.hide()
                    } else {
                      f7.tab.show('.toolbar.tabbar', '.tab-link-main', false)
                      $('#view-home, .view.tab-active').toggleClass('tab-active')
                      e.preventDefault();
                      return false
                    }
                  }

                  // this.$f7.tab.show('.toolbar.tabbar', '.tab-link-main', false)
                  // $('#view-home, .view.tab-active').toggleClass('tab-active')


                  // $('.view.tab-active').removeClass('tab-active')
                  // $('#view-home').addClass('tab-active')

                  // console.log(currentViewEl, mainViewEl)

                  // this.$f7.views.main.$el[0].addClass('tab-active');

                  // console.log('current view name:', this.$f7.views.current)

                  // const viewCategoryEl = $('#view-category')
                  // viewCategoryEl.addClass('tab-active')

                  // console.log('current view name:', this.$f7.views.current.name)

                  // // check most over views
                  // const viewSearchEl = $('#view-search')
                  // const viewCartEl = $('#view-cart')

                  // let currentView = null

                  // if (viewSearchEl && viewSearchEl.hasClass('most-over') && viewSearchEl.hasClass('modal-in')) {
                  //   currentView = this.$f7.views.get(viewSearchEl)
                  //   console.log(currentView.name)

                  //   viewSearchEl.hide()
                  //   e.preventDefault();
                  //   return false
                  // } else if (viewCartEl && viewCartEl.hasClass('most-over') && viewCartEl.hasClass('modal-in')) {
                  //   viewCartEl.hide()
                  //   e.preventDefault();
                  //   return false
                  // }
                }
                }
              />
            }
          </NavLeft>
          <NavTitle>
            {<div className={`page-title ${title ? '' : 'page-title-logo'}`}>{title}</div>}
          </NavTitle>
          <NavRight className={classes.search}>
            {showSearch &&
              <Link
                iconOnly
                icon="mdi-magnify"
                href="#"
                onClick={this.searchClicked}
              />
            }
            {showCart &&
              <Link
                iconOnly
                href="#"
                onClick={this.cartClicked}
              >
                <Icon icon="mdi-cart">
                  {cart.length !== 0 && <Badge className={classes.badge}>{cart.length}</Badge>}
                </Icon>
              </Link>
            }
          </NavRight>
        </Navbar>
        <div className={`${classes.fullContainer} ${background}`}>
          {this.props.children}
          {/* <div style={{ height: '30%' }} /> */}
        </div>
      </Page>
    )
  }
}

export default connect(
  state => ({
    env: state.General.env,
    cart: state.Cart.cart,
    category: state.Category.category
  }),
  {
    changeVisibleSearchView,
    changeVisibleCartView,
  }
)(withLocale('navbar')(autobind(SikaPage)));